import bbcode, { stripBBCode } from "../../controls/bbcode";
import { ComponentEx, translate } from "../../controls/ComponentEx";
import { getSafe } from "../../util/storeHelper";
import { truthy } from "../../util/util";
import { currentGame } from "../gamemode_management/selectors";
import { nexusGameId } from "../nexus_integration/util/convertGameId";
import BaseDashlet from "./BaseDashlet";
import { GAMEID_PLACEHOLDER, MAX_SUMMARY_LENGTH } from "./constants";
import rss from "./rss";
import * as React from "react";
import { connect as redConnect } from "react-redux";
class RSSDashlet extends ComponentEx {
    mMounted = false;
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentDidMount() {
        this.mMounted = true;
        this.refresh();
    }
    componentWillUnmount() {
        this.mMounted = false;
    }
    componentDidUpdate(oldProps) {
        if (oldProps.nexusGameId !== this.props.nexusGameId) {
            this.refresh();
        }
    }
    render() {
        const { t, emptyText, title } = this.props;
        const { error, messages } = this.state;
        return (React.createElement(BaseDashlet, { t: t, title: title, items: messages, error: error, emptyText: emptyText, onRefresh: this.refresh }));
    }
    refresh = () => {
        const { url } = this.props;
        const rssUrl = this.props.nexusGameId !== undefined &&
            url.indexOf(GAMEID_PLACEHOLDER) !== -1
            ? url.replace(GAMEID_PLACEHOLDER, this.props.nexusGameId)
            : url;
        rss(rssUrl)
            .then((result) => {
            if (this.mMounted) {
                this.setState({
                    messages: result
                        .map((item) => this.transformMessage(item))
                        .filter((item) => truthy(item)),
                    error: undefined,
                });
            }
        })
            .catch((err) => {
            if (this.mMounted) {
                this.setState({
                    error: err.message,
                });
            }
        });
    };
    transformMessage(input) {
        const { extras } = this.props;
        const image = input.enclosures.find((enc) => (!truthy(enc.type) || enc.type.startsWith("image/")) && truthy(enc.url));
        if (!image) {
            return undefined;
        }
        const messageInput = getSafe(input, ["nexusmods:summary", "#"], input.description);
        let summary = stripBBCode(messageInput);
        if (summary.length > MAX_SUMMARY_LENGTH) {
            summary = summary.substring(0, MAX_SUMMARY_LENGTH) + "...";
        }
        const convertValue = (value) => {
            if (typeof value === "object" && value["#"] !== undefined) {
                return value["#"];
            }
            return value;
        };
        return {
            name: bbcode(input.title),
            link: input.link,
            imageUrl: image.url,
            category: input.categories?.[0],
            summary,
            extra: extras.map((iter) => ({
                id: iter.text,
                text: iter.text,
                icon: iter.icon,
                value: convertValue(input[iter.attribute]),
            })),
        };
    }
}
function mapStateToProps(state) {
    const game = currentGame(state);
    const gameId = game !== undefined ? nexusGameId(game) : undefined;
    return {
        nexusGameId: gameId,
    };
}
export default translate(["common"])(redConnect(mapStateToProps)(RSSDashlet));
